import dailyGroupSalesReportApi from "../../api/report/dailyGroupSalesReportApi";

export interface DailyGroupSalesFilter {
    groupId: number;
    branchId?: number;
    date: string; // yyyy-MM-dd
}

const DailyGroupSalesReportService = {

    /** POST /api/reports/daily-group-sales/search */
    search: async (filter: DailyGroupSalesFilter) => {
        const response = await dailyGroupSalesReportApi.addCustom("/search", filter);
        return response.data;
    },

};

export default DailyGroupSalesReportService;
